import { SystemState } from './types'

export const getUserName = (state: SystemState) => state.user && state.user.name
export const getUserEmail = (state: SystemState) => state.user && state.user.email
export const isUserInActive = (state: SystemState) => state.user && state.user.inActive
export const isExistingUser = (state: SystemState) => state.user && state.user.existingUser
